<template>
  <div class="text-center flex justify-center" >
    <div style="max-width: 600px">
      <slot name="header"><h3 class="mb-4 mt-3">{{header}}</h3></slot>
      <img :src="require(`@/assets/images/${illustration}`)" style="max-height: 400px" class="mx-auto" alt="Empty state image">
      <h5 class="mx-auto mb-4" v-if="subheader">{{subheader}}</h5>
      <p class="mx-auto" v-if="subsubheader">{{subsubheader}}</p>
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
    header: {
      type: String,
      required: false,
    },
    subheader: {
      type: String,
      required: false,
    },
    subsubheader: {
      type: String,
      required: false,
    },
    illustration: {
      type: String,
      required: true,
    },
  },
}
</script>
